import { render, staticRenderFns } from "./Helpdesk.vue?vue&type=template&id=2623ee58"
import script from "./Helpdesk.vue?vue&type=script&lang=js"
export * from "./Helpdesk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports